import clsx from "clsx";
import style from "./style.module.scss";

type ButtonTextProps = {
    buttonText: string;
    className?: string;
    item?: {id: number, name: string, filterName: string};
    onClick?: (args: { id: number; name: string; filterName: string }) => void;
    id?:string;
}

const Button = ({buttonText, className, onClick, item,id=''}: ButtonTextProps) => {
  return (
    <button className={clsx(style.root, className)} onClick={() => typeof onClick === 'function' && onClick(item)} id={id}>
        {buttonText || ""}
    </button>
  )
}

export default Button;